import { render, staticRenderFns } from "./rfieldForm.vue?vue&type=template&id=d0c471fe&scoped=true&"
import script from "./rfieldForm.vue?vue&type=script&lang=js&"
export * from "./rfieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c471fe",
  null
  
)

export default component.exports